import { ObjectDb } from './object.db';
import { OrganizationGridItemObject, ServiceGridItemObject } from '@it2go/types';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OrganizationDb extends ObjectDb<OrganizationGridItemObject> {

    public tableName = 'organization';

    protected override columnMap = {};
    protected override checkField = 'updatedAt';

    protected gqlMethod = 'getOrganizations';

    protected syncFragment = `
        id
        name
        updatedAt
    `;

}
